export default {"src":"/_next/static/media/icCopy.8af01618.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};